import { render } from "./ProjectTile.vue?vue&type=template&id=053fc4f7"
import script from "./ProjectTile.vue?vue&type=script&lang=js"
export * from "./ProjectTile.vue?vue&type=script&lang=js"

import "./ProjectTile.vue?vue&type=style&index=0&id=053fc4f7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__